import React from "react";
import { motion, useScroll, useTransform, useSpring } from "framer-motion";

const BackgroundEffects = () => {
  const { scrollYProgress } = useScroll();

  const smoothProgress = useSpring(scrollYProgress, {
    stiffness: 80,
    damping: 25,
    mass: 0.4,
  });

  const orbOneY = useTransform(smoothProgress, [0, 1], [0, 700]);
  const orbOneX = useTransform(smoothProgress, [0, 1], [0, 220]);

  const orbTwoY = useTransform(smoothProgress, [0, 1], [0, -650]);
  const orbTwoX = useTransform(smoothProgress, [0, 1], [0, -180]);

  const orbThreeY = useTransform(smoothProgress, [0, 1], [0, 450]);

  const gridY = useTransform(smoothProgress, [0, 1], [0, -220]);

  const rotateGrid = useTransform(smoothProgress, [0, 1], [0, 4]);

  const glowScale = useTransform(smoothProgress, [0, 0.5, 1], [1, 1.25, 0.9]);

  return (
    <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none bg-[#050507]">
      {/* Base background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#050507] via-[#090912] to-[#0c0712]" />

      {/* RGB ambient glow */}
      <motion.div
        style={{
          y: orbOneY,
          x: orbOneX,
          scale: glowScale,
        }}
        className="
          absolute
          -left-52
          top-[8%]
          h-[550px]
          w-[550px]
          rounded-full
          bg-cyan-500/[0.065]
          blur-[140px]
        "
      />

      <motion.div
        style={{
          y: orbTwoY,
          x: orbTwoX,
        }}
        className="
          absolute
          -right-52
          top-[28%]
          h-[600px]
          w-[600px]
          rounded-full
          bg-purple-600/[0.065]
          blur-[150px]
        "
      />

      <motion.div
        style={{
          y: orbThreeY,
        }}
        className="
          absolute
          left-[35%]
          top-[55%]
          h-[450px]
          w-[450px]
          rounded-full
          bg-pink-500/[0.045]
          blur-[140px]
        "
      />

      {/* Moving RGB center glow */}
      <motion.div
        style={{
          y: orbOneY,
          rotate: rotateGrid,
        }}
        className="
          absolute
          left-[40%]
          top-[20%]
          h-[300px]
          w-[300px]
          rounded-full
          bg-blue-500/[0.035]
          blur-[110px]
        "
      />

      {/* RGB light line */}
      <motion.div
        style={{
          x: orbOneX,
          y: orbOneY,
        }}
        className="
          absolute
          left-1/2
          top-[15%]
          h-[1px]
          w-[55%]
          -translate-x-1/2
          bg-gradient-to-r
          from-transparent
          via-cyan-400/20
          to-transparent
          blur-[1px]
        "
      />

      {/* Moving grid */}
      <motion.div
        style={{
          y: gridY,
          rotate: rotateGrid,
        }}
        className="absolute inset-0 opacity-[0.035]"
      >
        <div
          className="absolute inset-[-150px]"
          style={{
            backgroundImage: `
              linear-gradient(rgba(0,255,255,0.55) 1px, transparent 1px),
              linear-gradient(90deg, rgba(168,85,247,0.55) 1px, transparent 1px)
            `,
            backgroundSize: "75px 75px",
          }}
        />
      </motion.div>

      {/* Floating particles */}
      <motion.div
        style={{ y: orbTwoY }}
        className="absolute left-[15%] top-[45%] h-2 w-2 rounded-full bg-cyan-400/40 blur-[1px]"
      />

      <motion.div
        style={{ y: orbOneY }}
        className="absolute left-[70%] top-[20%] h-1.5 w-1.5 rounded-full bg-purple-400/50"
      />

      <motion.div
        style={{ y: orbThreeY }}
        className="absolute left-[80%] top-[70%] h-2 w-2 rounded-full bg-pink-400/40 blur-[1px]"
      />

      {/* Vignette */}
      <div
        className="
          absolute
          inset-0
          bg-[radial-gradient(circle_at_center,transparent_0%,rgba(5,5,7,0.28)_65%,rgba(5,5,7,0.8)_100%)]
        "
      />
    </div>
  );
};

export default BackgroundEffects;
